/* eslint-disable no-bitwise */
import { getI18nMap, getI18nDefaultFormat } from './i18n'


const { REACT_APP_ENV } = process.env

export default (locale, flyerId) => {
  const prefix = ~['dev', 'stg'].indexOf(REACT_APP_ENV) ? 'stg-' : ''
  const { ISO639, ISO3166_1 } = getI18nMap(getI18nDefaultFormat(locale))
  const country = `${ISO639}-${ISO3166_1.toLowerCase()}`
  
  if (country === 'es-es' || country === 'pt-pt') {
    const urlCountry = country.replace('-', '_')
    return `//d1h08qwp2t1dnu.cloudfront.net/assets/media/${urlCountry}/images/volantini/${flyerId}@3x.jpg`
  }
  
  return `//${prefix}${country}-media.shopfully.cloud/images/volantini/${flyerId}@3x.jpg`
}
